<template>
  <v-simple-table dense>
    <template v-for="(subTable, l) in tables">
      <thead class="table-header" :key="`${l}-title`">
        <tr>
          <th
            class="text-left"
            v-for="(header, k) in subTable.table.header"
            :key="`header-${k}-${header}`"
            :style="headerStyle(k)"
          >
            {{ header }}
            <!-- Temporary -->
          </th>
        </tr>
      </thead>
      <tbody :key="`${l}-body`">
        <tr v-for="(row, i) in subTable.table.rows" :key="`row-${i}-${l}`">
          <td
            v-for="(col, j) in row"
            :key="`col-${i}-${j}`"
            :class="{
              'table-header': firstColumnHeader && j === 0,
              'font-weight-bold': subTable.lastRowBold && i === subTable.rows.length - 1,
            }"
          >
            {{ formattedValue(col, subTable.format) }}
          </td>
        </tr>
        <!-- No data for that subtable -->
        <tr v-if="!subTable.table.rows || !subTable.table.rows.length">
          <td>No data</td>
          <td v-for="i in subTable.table.header.length - 1" :key="`no-data-row-${i}-${l}`"></td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { DateTime } from "luxon";
import { formatNumberD3 } from "@/plugins/utils";

export default {
  name: "TableSimple",
  components: {},
  mixins: [],
  props: {
    data: { type: Array, required: false, default: () => [] },
    firstColumnHeader: { type: Boolean, required: false, default: false },

    // Formating follows this rule
    // https://d3js.org/d3-format
    globalFormat: { type: String, required: false, default: "" },
    formatHeader: { type: Boolean, required: false, default: true },
  },
  data() {
    return {};
  },
  computed: {
    tables() {
      if (!this.data.length) {
        return [];
      }
      if (this.data[0].format === undefined) {
        return this.data.map((subTable) => ({ table: subTable, format: this.globalFormat }));
      }
      return this.data;
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    formattedValue(val, stringFormat) {
      if (typeof val === "object") {
        if (DateTime.fromJSDate(val).isValid) {
          return DateTime.fromJSDate(val).toLocaleString(DateTime.DATE_SHORT);
        }
        return val;
      }
      if (Number(val) && (Number(val) > 2025 || Number(val < 1950))) {
        if (stringFormat) {
          return formatNumberD3(val, stringFormat);
        }
        return formatNumberD3(val);
      }
      return val;
    },

    headerStyle(idx) {
      // Vertical-align property is being overwritten elsewhere
      if (idx === 0) {
        return `user-select: text; min-width: 210px !important; vertical-align: middle;`;
      }
      return `user-select: text; vertical-align: middle;`;
    },
  },
};
</script>

<style>
.table-header {
  background-color: #306d8a;
  color: white;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: white;
}
</style>
